import { isArcGisWfsLayer } from './isArcGisLayer'
import { GeoJSON, WFS } from 'ol/format'
import axios from 'axios'

const ArcGisWfsQuery = map => {
  const wfsFormat = new WFS()
  const geoJsonFormat = new GeoJSON()

  const arcGisWfsQuery = options => {
    const bbox = `${options.extent.join(',')},${options.srsName}`

    var url = options.baseUrl || 'https://olgatest.scaskog.com/ows/wfs'

    var params = {
      SERVICE: 'WFS',
      VERSION: '2.0.0',
      REQUEST: 'GetFeature',
      TYPENAME: options.featureType,
      OUTPUTFORMAT: 'GML3',
      SRSNAME: options.srsName,
      bbox
    }

    if (options.access_token) {
      params.access_token = options.access_token
    }

    return axios
      .get(url, { params })
      .then(response =>
        geoJsonFormat.writeFeaturesObject(wfsFormat.readFeatures(response.data))
      )
  }

  const query = (layer, queryOptions) => {
    const srsName = map
      .getView()
      .getProjection()
      .getCode()
    return arcGisWfsQuery({
      baseUrl: layer.metadata.baseUrl,
      featureType: layer.metadata.featureType,
      srsName: srsName,
      layer: layer,
      extent: queryOptions.extent,
      access_token: layer.source.params.access_token
    }).catch(err => {
      console.error('arcGisWfsQuery: Failed to query', layer.name, err)
      return []
    })
  }

  const isLayerSupported = layer =>
    isArcGisWfsLayer(layer) &&
    (layer.source.type === 'TileWMS' || layer.source.type === 'ImageWMS')

  return {
    query,
    isLayerSupported
  }
}

export default ArcGisWfsQuery
